import React from 'react';
import { useSelector } from 'react-redux';
import Icon from '../../../../../components/ui/icons/Icon';
import iconsList from '../../../../../components/ui/icons/iconsList';
import classes from './StatisticsCounters.module.css';

const StatisticsCounters = ({ items, dropClass }) => {

    const { texts } = useSelector((state) => state.translate);

    return (
        <div className={`${classes.statisticsCounters}  ${dropClass}`}>
            <div className={classes.itemsContainer}>
                <div className={classes.itemsTopics}>
                    {items.map((item, index) => (
                        <div key={index}>
                            <div className={classes.itemHeader}>
                                <span className={classes.itemTopic} title={item.tooltipKey && texts[item.tooltipKey]}>
                                    {item.showStar ? <Icon name={iconsList.countersStar} size="26px" /> : <div className={classes.emptyStar} />}
                                    {item.text}
                                </span>
                                <div key={index}>
                                    <span className={classes.itemNumber}>{item.number}</span>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default StatisticsCounters;

